// extracted by mini-css-extract-plugin
export var col = "Content-col-jMOLU";
export var root = "Content-root-ToBh-";
export var rootButton = "Content-root_button-3Wy1x";
export var rootCol = "Content-root_col-xPcq9";
export var rootColText = "Content-root_col-text-6b2Qz";
export var rootDescription = "Content-root_description-iihxM";
export var rootHeading = "Content-root_heading-+ZKAD";
export var rootImage = "Content-root_image-586GV";
export var rootItemDescription = "Content-root_itemDescription-FQhd5";
export var rootItemHeading = "Content-root_itemHeading-B2qja";
export var rootList = "Content-root_list-ZgFgb";
export var rootListHeading = "Content-root_listHeading-6a7aT";
export var rootListItem = "Content-root_listItem-ou0PI";
export var rootListItemIcon = "Content-root_listItemIcon-D6FXO";
export var rootListItemText = "Content-root_listItemText-Kuszo";
export var rootPicture = "Content-root_picture-QtW5Y";
export var rootPictureReversed = "Content-root_picture-reversed-E6hyT";
export var rootRow = "Content-root_row-2gVh5";
export var rootTextWrapper = "Content-root_textWrapper-3J7rm";